import type { ContractChangeStatusEnum } from 'gql/graphql';
import { useProjectData } from 'hooks/useProjectData';
import { useSendGpnAnalyticsEvent } from 'hooks/useSendGpnAnalyticsEvent';
import { Button } from 'uikit';

import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { AddOrEditAgreementModal } from '../AddOrEditAgreementModal';

export const EditAgreement = ({
    currentContractId,
    currentAgreementId,
    currentAgreementStatus,
    refreshHandler,
    className,
    needUpdateCurrentPriceList,
    needUpdatePriceListHandler,
    isDisabledByProjectStatus,
    isDisabledByContractStatus,
    rulesAccessDisabled,
}: {
    currentContractId: number;
    currentAgreementId: number;
    currentAgreementStatus: ContractChangeStatusEnum | undefined;
    isDisabledByProjectStatus: boolean;
    isDisabledByContractStatus: boolean;
    refreshHandler: () => void;
    needUpdateCurrentPriceList?: boolean;
    needUpdatePriceListHandler?: (nextState: boolean) => void;
    className: string;
    rulesAccessDisabled: boolean;
}) => {
    const { id: projectId } = useParams();

    const { projectData } = useProjectData(projectId, false);

    const { sendGpnAnalyticsEvent } = useSendGpnAnalyticsEvent();

    const [editModalOpened, setEditModalOpened] = useState(false);

    const openEditModalHandler = useCallback(() => {
        setEditModalOpened(true);

        sendGpnAnalyticsEvent({
            componentId: 'rim_edite DS button_pressed',
            projectId,
            contractId: currentContractId,
            agreementId: currentAgreementId,
            agreementStatus: currentAgreementStatus,
            projectName: projectData?.name,
            projectType: projectData?.contractType,
            projectDO: projectData?.subsidiary?.name,
            methodology: projectData?.methodology,
        });
    }, [
        currentAgreementId,
        currentAgreementStatus,
        currentContractId,
        projectData?.contractType,
        projectData?.methodology,
        projectData?.name,
        projectData?.subsidiary?.name,
        projectId,
        sendGpnAnalyticsEvent,
    ]);

    const closeEditDialogHandler = useCallback(() => {
        setEditModalOpened(false);
    }, []);

    return (
        <>
            <Button
                label="Реквизиты ДС"
                view="secondary"
                size="s"
                onClick={openEditModalHandler}
                className={className}
                disabled={rulesAccessDisabled}
            />
            {editModalOpened && (
                <AddOrEditAgreementModal
                    currentContractId={currentContractId}
                    isModalOpened={editModalOpened}
                    closeHandler={closeEditDialogHandler}
                    refreshHandler={refreshHandler}
                    currentAgreementItemId={currentAgreementId}
                    needUpdateCurrentPriceList={needUpdateCurrentPriceList}
                    needUpdatePriceListHandler={needUpdatePriceListHandler}
                    isDisabledByProjectStatus={isDisabledByProjectStatus}
                    isDisabledByContractStatus={isDisabledByContractStatus}
                />
            )}
        </>
    );
};

EditAgreement.displayName = 'EditAgreement';
